import * as React from 'react';
import { bindActionCreators } from 'redux';
import { flow, get } from 'lodash';
import { connect } from 'react-redux';
import { IAuthState } from '../../../../services/auth/models';
import { actions as authActions, IAuthActions } from '../../../../services/auth/reducer';
import { IBrandingState } from '../../../../services/branding/models';
import Loading from '../../../../components/Loading';
import { withJob } from 'react-jobs';
import { IStore } from '../../../../redux/IStore';
import { FaSpinner } from 'react-icons/fa';
import Heap from '../../../../helpers/Heap';
import { paymentMethodActions } from '../../../../services/paymentMethod/actions';
import { IPaymentMethodActions } from '../../../../services/paymentMethod/models';

interface ICustomerClaimsProps {
  auth: IAuthState;
  actions: {
    push: (route: string) => void;
    auth: IAuthActions;
    paymentMethod: IPaymentMethodActions;
  };
  branding?: IBrandingState;
}

interface ICustomerClaimsState {
  loading: boolean;
}

class CustomerClaims extends React.Component<ICustomerClaimsProps, ICustomerClaimsState> {
  public state = {
    loading: false,
  };

  constructor(props) {
    super(props);
    this.initHeap();
  }

  private initHeap = () => {
    const { auth, actions } = this.props;
    const sortedPolicyByDate = actions.auth.getLatestPolicy();

    Heap.trackActivePolicyEvent(
      'EnterClaimsPage',
      sortedPolicyByDate,
      get(auth, 'customer.marketingOptions'),
      actions.paymentMethod.getPolicyPaymentMethod(get(sortedPolicyByDate, 'assignedPaymentMethods'))
    );
  }

  public componentDidMount(): void {
    const { actions, auth } = this.props;

    if (auth.customer.claimsIframeUrl) {
      return;
    }

    this.setState({ loading: true });

    actions.auth.getCustomerClaimsIframeUrl().then((url) => {
      Heap.track('ClaimsShowing', { success: url !== null })
      this.setState({ loading: false });
    });
  }

  public render() {
    const { loading } = this.state;

    return (
      <div className="page-container">
        {loading && (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <FaSpinner className="fa-spin" style={{ fontSize: '4em' }}/>
            <div style={{ marginLeft: '15px', fontStyle: 'italic', fontSize: '25px' }}>Loading your claims information,
              please wait…
            </div>
          </div>
        )}

        {!loading && this.renderClaims()}
      </div>
    );
  }

  private renderClaims() {
    const { auth } = this.props;
    const claimsUrl = auth.customer.claimsIframeUrl || '';
    return (
      <>
        {!claimsUrl && (
          <div className={'mt-30'}>
            <p>
              It can take upto 24 hours before you can access the claims area, please check back later if you
              wish to make a claim - if you still can’t access this area, please email <a
              href={'mailto:travelinsurance@admiralgroup.co.uk'}>travelinsurance@admiralgroup.co.uk</a>.
            </p>
          </div>
        )}

        {claimsUrl && (
          <div className={'mt-30'}>
            <iframe
              id="claims-iframe"
              src={claimsUrl}
              style={{ width: '1px', minWidth: '100%' }}
            />
          </div>
        )}
      </>
    );
  }
}

export default flow([
  withJob({
    work: (props: ICustomerClaimsProps) => {
      const promises = [];

      promises.push(props.actions.auth.reloadCustomer());

      return Promise.all(promises);
    },
    LoadingComponent: () => <Loading/>,
    ErrorComponent: ({ error }) => {
      console.error(error);

      return (
        <div>
          {error.message}
        </div>
      );
    },
  }),
  connect(
    (state: IStore) => {
      return {
        auth: state.auth,
        quote: state.quote,
        branding: state.branding,
      };
    },
    (dispatch) => ({
      actions: {
        auth: bindActionCreators({ ...authActions }, dispatch),
        paymentMethod: bindActionCreators({ ...paymentMethodActions }, dispatch),
      },
    }),
  ),
])(CustomerClaims);
